export enum QueryWhereOperator {
	EQ = 'eq',
	NEQ = 'neq',
	GT = 'gt',
	GTE = 'gte',
	LT = 'lt',
	LTE = 'lte',
	LIKE = 'like',
	ILIKE = 'ilike',
}

export type QueryValue = string | number | boolean | null;

export interface IWhereRawClause {
	name: string;
	operator?: QueryWhereOperator;
	value: QueryValue;
}

export interface IWhereClause extends IWhereRawClause {
	and?: IWhereClause[];
	or?: IWhereClause[];
}

export interface ISelectQuery {
	from: {
		name: string;
	};
	items: {
		name: string;
	}[];
	where?: IWhereClause[];
	sorts?: {
		name: string;
		direction: 'asc' | 'desc';
	}[];
	limit?: number;
	offset?: number;
}

export interface IInsertQuery {
	into: {
		name: string;
	};
	items: {
		name: string;
		value: QueryValue;
	}[];
}

export interface IUpdateQuery {
	table: {
		name: string;
	};
	set: {
		name: string;
		value: QueryValue;
	}[];
	where: IWhereClause[];
}

export interface IDeleteQuery {
	from: {
		name: string;
	};
	where: IWhereClause[];
}

export interface IQueryRequest {
	select?: ISelectQuery;
	insert?: IInsertQuery;
	update?: IUpdateQuery;
	delete?: IDeleteQuery;
}
